export class BasketPriceModel {
    public value: number;
}